module.exports = __webpack_public_path__ + "img/gaia48-wechat.42c656c6.png";